module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_41.3bfbd82f.jpg";